export type IACKATHON_STEP =
    | "keyNumber"
    | "problematic"
    | "howNowWow"
    | "finalIdea"
    | "canvas"
    | "deliverable"
    | "ratingOthers"
    | "rate"

export const IACKATHON_STEP_LABEL_KEY: Record<IACKATHON_STEP, string> = {
    keyNumber: 'iackathon.key_number',
    problematic: 'iackathon.problematic',
    howNowWow: 'iackathon.how_now_wow',
    finalIdea: 'iackathon.final_idea',
    canvas: 'iackathon.canvas',
    deliverable: 'iackathon.deliverable',
    ratingOthers: 'iackathon.rating_others',
    rate: 'iackathon.rate',
};